import { Controller } from "@hotwired/stimulus"
import { useEscapeKey } from "../helpers/escape_key_mixin"

export default class extends Controller {
  static targets = ["menu", "burger"]

  connect() {
    this.escapeKey = useEscapeKey(this, this.closeOnEscape)
  }

  disconnect() {
    this.escapeKey.remove()
  }

  toggle(event) {
    event.preventDefault()
    const open = !this.menuTarget.classList.contains("is-active")
    this.setOpen(open)
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return
    if (!this.menuTarget.classList.contains("is-active")) return
    this.setOpen(false)
  }

  setOpen(open) {
    this.menuTarget.classList.toggle("is-active", open)
    this.burgerTarget.classList.toggle("is-active", open)
    this.burgerTarget.setAttribute("aria-expanded", open ? "true" : "false")
    if (open) {
      this.escapeKey.add()
    } else {
      this.escapeKey.remove()
    }
  }
}
